<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentCreated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentCreated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                agentName: this.$_.get(this.activity, 'payload.agentName'),
                agentId: this.$_.get(this.activity, 'payload.agentId')
            });
        }
    }
};
</script>

